const RequestRideStatus = {
    UNKNOWN: 'UNKNOWN',
    FINDING_A_RIDE: 'FINDING_A_RIDE',
    CONFIRMING_PICKUP: 'CONFIRMING_PICKUP',
};

const RideStatus = {
    BOOKING_INITIALIZED: 'BOOKING_INITIALIZED',
    BOOKING_QUEUED: 'BOOKING_QUEUED',
    WAITING_FOR_DRIVER_TO_ACCEPT: 'WAITING_FOR_DRIVER_TO_ACCEPT',
    DRIVER_ON_ROUTE_TO_PICKUP: 'DRIVER_ON_ROUTE_TO_PICKUP',
    DRIVER_ARRIVED_AT_PICKUP: 'DRIVER_ARRIVED_AT_PICKUP',
    OTP_VERIFIED_DESTINATION_INPUT_PENDING: 'OTP_VERIFIED_DESTINATION_INPUT_PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    IN_PROGRESS_CLOSE_TO_DESTINATION: 'IN_PROGRESS_CLOSE_TO_DESTINATION',
    CUSTOMER_DROPPED_OFF_PAYMENT_PENDING: 'CUSTOMER_DROPPED_OFF_PAYMENT_PENDING',
    CUSTOMER_CLAIMED_PAYMENT_BY_CASH: 'CUSTOMER_CLAIMED_PAYMENT_BY_CASH',
    COMPLETED: 'COMPLETED',
};

export { RequestRideStatus, RideStatus };
